import { AlertCircle } from "lucide-react";

export default function CompleteProfilePrompt({
  open,
  missingFields = [],
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full">
        <div className="flex items-center gap-3 mb-4">
          <AlertCircle className="text-orange-500" />
          <h2 className="text-lg font-semibold">
            Complete Your Profile
          </h2>
        </div>

        <p className="text-gray-600 text-sm mb-4">
          Please complete the following information before continuing:
        </p>

        <ul className="space-y-2 mb-6">
          {missingFields.map((field) => (
            <li
              key={field}
              className="bg-orange-50 text-orange-700 px-3 py-2 rounded-lg text-sm"
            >
              {field}
            </li>
          ))}
        </ul>

        <button
          onClick={() => {
            window.location.href = "/account";
          }}
          className="w-full bg-[#3866A3] text-white py-3 rounded-xl font-medium"
        >
          Complete Profile
        </button>
      </div>
    </div>
  );
}